import { Languages } from './top-menu/top-menu';

export const GetLanguageLabel = (labels: { language: Languages; label: string }[]): string => {
  return (
    labels.find((x) => window.location.href.indexOf('/' + x.language + '/') !== -1)?.label ?? ''
  );
};
